import React from "react";
import ValueInput from "../ValueInput/ValueInput";
import { ValmetGrey4 } from "../../theme";
import { makeStyles, createStyles } from "@material-ui/styles";
import { Checkbox, FormControlLabel, Tooltip, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { StoreState } from "models";

interface Props {
  tagName: string;
  value: number | null | undefined;
  description?: string;
  type: string;
  override?: boolean | undefined;
  changeValue: (type: string, tagName: string, update: { newPosition?: number; override?: boolean }) => void;
}

const localStyles = makeStyles(() =>
  createStyles({
    damperRow: {
      display: "flex",
      alignItems: "center",
      color: ValmetGrey4,
      fontSize: "13px",
      letterSpacing: "0.00938em",
    },
  }),
);

const DamperPositionRow: React.FC<Props> = ({ tagName, value, description, override, type, changeValue }) => {
  const localClasses = localStyles();
  const submitting = useSelector((state: StoreState) => state.fuelComposition.submitPending);

  const changeDamperValue = (newPosition: number): void => {
    changeValue(type, tagName, { newPosition });
  };

  const toggleDefaultValue = (): void => {
    changeValue(type, tagName, { override: !override });
  };

  return (
    <div className={localClasses.damperRow}>
      {value !== undefined && (
        <Tooltip title={override ? "Use default value" : "Override damper position"} placement="top">
          <FormControlLabel
            control={
              <Checkbox
                checked={override}
                onChange={toggleDefaultValue}
                name="toggleOverride"
                color="primary"
                disabled={submitting}
                tabIndex={-1}
              />
            }
            label=""
          />
        </Tooltip>
      )}

      <ValueInput
        id={tagName}
        title={tagName}
        loading={submitting}
        type={type}
        sign="%"
        isValid={value !== null}
        isDisabled={!override}
        max={100}
        min={0}
        value={value}
        handleValueChange={changeDamperValue}
      />

      {description && <Typography variant="caption">{description}</Typography>}
    </div>
  );
};

export default React.memo(DamperPositionRow);
